import { Localization } from "../../../../common/localizable-component";
import { FilePreviewLocalization } from "./file-preview-types";
export const FILE_PREVIEW_LOCALIZATION: Localization<FilePreviewLocalization> = {
  en: {
    completedString: "completed",
    errorMessageString: "An unexpected error occurred, please try again"
  },
  de: {
    completedString: "Erfolgreich",
    errorMessageString: "Ein unerwarteter Fehler ist aufgereten, versuchen Sie es bitte erneut"
  },
  sv: {
    completedString: "avslutad",
    errorMessageString: "Ett oväntat fel inträffade, vänligen försök igen."
  },
  nl: {
    completedString: "voltooid",
    errorMessageString: "Er is een onverwachte fout opgetreden, probeer het opnieuw."
  },
  it: {
    completedString: "completato",
    errorMessageString: "Si è verificato un errore imprevisto, si prega di riprovare"
  },
  hu: {
    completedString: "Kész",
    errorMessageString: "Váratlan hiba történt, kérjük, próbálja újra!"
  },
  da: {
    completedString: "færdig",
    errorMessageString: "En uventet fejl opstod, prøv venligst igen"
  },
  fr: {
    completedString: "terminé",
    errorMessageString: "Une erreur inattendue s'est produite, veuillez réessayer"
  },
  es: {
    completedString: "completado",
    errorMessageString: "Se ha producido un error inesperado, inténtelo de nuevo"
  },
  pl: {
    completedString: "zakończone",
    errorMessageString: "Wystąpił nieoczekiwany błąd, spróbuj ponownie"
  },
  ro: {
    completedString: "completat",
    errorMessageString: "A apărut o eroare neașteptată, vă rugăm să încercați din nou"
  },
  hr: {
    completedString: "dovršeno",
    errorMessageString: "Došlo je do neočekivane pogreške, pokušajte ponovo"
  },
  cs: {
    completedString: "dokončeno",
    errorMessageString: "Došlo k neočekávané chybě, zkuste to prosím znovu."
  },
  sl: {
    completedString: "izpolnjen",
    errorMessageString: "Zgodila se je nepričakovana napaka, poskusite znova"
  }
};
